import Cookies from 'js-cookie';
import { stringToBoolean, detectZoom } from '../helpers/helpers';

export function accessibility() {
    //button toggle to switch aria-pressed labels

    $(document).on('click keypress', '.js-btn-toggle', function (e) {
        if (e.which === 1 || e.which === 13) {
            const $this = $(this);

            e = e || window.event;

            if ($this.attr('aria-expanded') == 'true') {
                $this.removeAttr('aria-expanded');
            } else {
                $this.attr('aria-expanded', 'true');
            }
        }
    });

    const $sbButton = $('#btn-sidebar-toggle');
    const $sbContainer = $('#mp-menu');
    const strIsCollapsed = Cookies.get('sidebarCollapsed') !== 'true' ? 'false' : Cookies.get('sidebarCollapsed');
    var isCollapsed = stringToBoolean(strIsCollapsed);

    //if tabbing on sidebar toggle, set focus to sidebar menu if its open
    $sbButton.keydown(function (e) {
        if (!isCollapsed && e.which === 9) {
            //re-enable tab index for toolbox items
            $sbContainer.find('a, button').attr('tabindex', '0');

            e.preventDefault();
            $sbContainer.find('a').eq(0).focus();
        }
    });

    //when tabbing on last item in sidebar, set focus to first tabbable item in main content
    $sbContainer
        .find('button')
        .last()
        .keydown(function (e) {
            if (e.which === 9) {
                e.preventDefault();
                $('.content-inner-header').find('a, button').eq(0).focus();

                //temporarily set tabindex to -1 so that this section is skipped from the normal tab index
                $sbContainer.find('a, button').attr('tabindex', '-1');
            }
        });

    window.addEventListener('resize', detectZoom);
    detectZoom();

    $(document).on('keydown', function (e) {
        if (e.key === 'Tab') {
            let $focusedElement = $(document.activeElement);

            let $dropdown = $('.menu-login_list-item.dropdown.open'); // The open dropdown
            if ($dropdown.length && $dropdown.has($focusedElement).length) {
                setTimeout(function () {
                    let $newFocusedElement = $(document.activeElement);
                    // Check if the new focused element is outside the dropdown and its children
                    if (!$dropdown.has($newFocusedElement).length) {
                        // Fire your event here
                        $('.menu-login_list-item.dropdown').removeClass('open');
                    }
                }, 10); // Small delay to allow focus shift
            }

            if ($focusedElement.hasClass('nativechat-launcher-icon-close')) {
                setTimeout(function () {
                    let $newFocusedElement = $(document.activeElement);
                    // Check if the new focused element is NOT the original element
                    if (!$newFocusedElement.hasClass('nativechat-launcher-icon-close')) {
                        
                        // if ( $newFocusedElement.hasClass('aoc') ) {
                            $('.nativechat-launcher-icon-close').click();
                        // }
                    }
                }, 10); // Small delay to allow focus shift
            }

            // console.clear();
            // console.log( '$focusedElement', $focusedElement );
            // if ( $focusedElement.closest('.u-select-multiple') ) {
            //     alert('test');
            // }
        }

        if (e.key == 'Escape') {

            // menu
            if ( $('html').hasClass('menu-open') ) {
                $('.dl-mobile-menu-close').click();
            }
        }
    });

//     $(document).on('keydown', function() {
//         let $focusedElement = $(document.activeElement);
// 
//         console.clear();
//         console.log($focusedElement, $focusedElement.text());
//     })

    $(document).on('click', '.search-results__contacts-table-actions .expand-action', function() {
        const $this = $(this);
        const $target = $( $this.attr('data-target') );

        setTimeout(() => {
            $target.removeAttr('aria-expanded');
            if ( $target.attr('aria-hidden') == 'true' ) {
                $target.attr('aria-hidden', 'false');
            } else {
                $target.attr('aria-hidden', 'true');
            }
        }, 500);
    });

    $(document).on('focus', '.panel-body form select.u-select-multiple, #s_widget_forms-docs form select.u-select-multiple', function() {
        const $this = $(this);
        const id = $this.attr('id');
        const $target = $('#btnlbl' + id);
        $target.click().focus();
    })

    $('.dl-landing a, .dl-menu__logout').on('keydown', function (e) {
        if (e.key === 'Tab' && !e.shiftKey) {
            $('.dl-mobile-menu-close').click();
        }
    });

    $('.nativechat-launcher-icon-close, .nativechat-launcher-icon-open').on('keyup', function(e) {

        if (e.key === 'Enter') {
            $(this).click();
        }
    });

    // nativechat-iframe-kcChatWindow
    $('.nativechat-launcher-icon-open').on('click', function() {
        const nativeChatIframe = $('.nativechat-launcher-modal iframe');
        // Bit of delay just in case
        setTimeout(() => {
            nativeChatIframe.attr('title', 'Native Chat');
        }, 100);


    });

    iframeTitles();

    $('form').each(function() {
        const $form = $(this);
        const $firstH2 = $form.find('h2').first();
        const legend = $('<legend class="sr-only"></legend>').text($firstH2.text() ?? 'Form');

        // transform it to h3
        $firstH2.replaceWith(`<h3>${$firstH2.text()}</h3>`);

        if ( $form.find('fieldset').length < 1 ) {
            $form.children().wrapAll('<fieldset/>');
            $form.find('fieldset').prepend(legend);
        }
    });

    tablePresentation();
}

function iframeTitles() {
    $('iframe').each((i) => {
        const $iframe = $(this);
        $iframe.attr('title', `Iframe ${i}`);
    });
}

function tablePresentation() {
    $('table').each(function() {
        const $table = $(this);
        $table.attr('role', 'presentation');
    });
}